import React from 'react'
import { THEME } from 'utils'

export default function EllipsisIcon({ color = THEME.COLORS.TEXTCOLOR, width = '18px', height = '18px' }) {
  return (
    <svg viewBox='0 0 18 4' className='svgIcon iconEllipsis' style={{ width, height }}>
      <title>More</title>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g transform='translate(-200.000000, -389.000000)' fill={color}>
          <g transform='translate(56.000000, 372.000000)'>
            <g transform='translate(134.000000, 0.000000)'>
              <g transform='translate(10.450000, 17.100000)'>
                <circle cx='1.9' cy='1.9' r='1.9' />
                <circle cx='8.55' cy='1.9' r='1.9' />
                <circle cx='15.2' cy='1.9' r='1.9' />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
